import React from "react";
import { Avatar, Badge, Rate, Tooltip } from "antd";
import { BiLinkExternal } from "react-icons/bi";
import locationIcon from "../../assets/icons/akar-icons_location.svg";
import { FiUserCheck } from "react-icons/fi";
import { impersonate } from "../../utils/Utils";
import { USER_TYPE } from "../../constant";

const UserCard = ({ userData }) => {
  const circumference = 2 * Math.PI * 50;
  const strokeDashoffset = circumference - (userData?.Profiles?.ProfileComletion / 100) * circumference;

  const smallCircleStyle = {
    position: "absolute",

    transform: `rotate(${-userData?.Profiles?.ProfileComletion * 3.6}deg) translateY(-${
       50 - 11 + 10
    }px)`,
  };

  return (
    <div className="DashBoard-Profile-Container">
      <div className="DashBoard-Profile-User-Info">
        <div className="DashBoard-Profile-Avatar-section">
          <div className="DashBoard-Profile-Avatar-section-Mobile">
            <div className="circular-progress-bar-container">
              <svg
                className="circular-progress-bar2"
                style={{ width: `100px`, height: `100px` }}
              >
                <svg className="circular-progress-bar">
                  <circle
                    className="progress-bar-background"
                    cx={50}
                    cy={50}
                    r={47.5}
                  />

                  <circle
                    className="progress-bar"
                    cx={50}
                    cy={50}
                    r={47.5}
                    strokeDasharray={`${circumference} ${circumference}`}
                    strokeDashoffset={-strokeDashoffset}
                  />
                </svg>
              </svg>

              <Tooltip
                placement="right"
                title={`Your 3D resume is ${userData?.Profiles?.ProfileComletion}% completed`}
                overlayClassName="CircularProgressTooltip"
                trigger={"hover"}
              >
                <div
                  className={"small-circle"}
                  style={smallCircleStyle}
                >
                  <div
                    className="percentage-text"
                    style={{
                      transform: `rotate(${userData?.Profiles?.ProfileComletion * 3.6}deg)`,
                    }}
                  >
                    {Math.floor(userData?.Profiles?.ProfileComletion, 0)}%
                  </div>
                </div>
              </Tooltip>
            </div>
            <div className="DashBoard-Profile-Avatar">
              <Badge
                color={"#118936"}
                className="ProfileAvatar"
                dot={false}
                offset={[-5, 35]}
              >
                <Avatar
                  size={70}
                  src={`${process.env.REACT_APP_S3_URL}/${userData?.Profiles?.PictureUrl}`}
                  className={"avatarBgColor"}
                >
                  {userData?.Profiles?.FirstName?.slice(0, 1)?.toUpperCase()}
                </Avatar>
              </Badge>
            </div>
          </div>
          <div className="DashBoard-Profile-user-Mobile">
            <div className="DashBoard-Profile-user-name">
              {userData?.Profiles?.FirstName
                ? `${userData?.Profiles?.FirstName} ${userData?.Profiles?.LastName}`
                : "NA"}
            </div>
            <div className="DashBoard-Profile-user-Profession-Code">
              {userData?.Professions?.ProfessionCode
                ? `${userData?.Professions?.ProfessionCode}`
                : "NA"}
            </div>
            <div className="DashBoard-Profile-user-rating-section">
              <div className="DashBoard-Profile-user-rating-star">
                <Rate count={1} size="small" disabled defaultValue={1} />
              </div>

              <div className="DashBoard-Profile-user-rating-number">
              {userData?.Profiles?.Rating} out of 5
              </div>
            </div>

            <div className="usercontainer-location-citizen">
              <img src={locationIcon} alt="" />
              <div style={{ marginRight: "0.6rem" }}>{userData?.Profiles?.Location?.Location ? userData?.Profiles?.Location?.Location : "NA" }</div>
              <FiUserCheck />
              <div>{userData?.Profiles?.VisaStatuses?.VisaStatusName}</div>
            </div>
          </div>
        </div>
        <div
          className="view-dashboard-user"
          onClick={() => impersonate(USER_TYPE.CANDIDATE, userData?._id)}
        >
          View test's Dashboard <BiLinkExternal fontSize="1.25rem" />
        </div>
      </div>
    </div>
  );
};

export default UserCard;
